import { mergeDeepLeft } from 'ramda';

// Utils made because of ramda's type inheritance issues
export const assign = <P extends object, S extends object>(patch: P, target: S): S => {
	return mergeDeepLeft(patch)(target) as S;
};
